module.exports = __webpack_public_path__ + "media/images/homes/arrow-3-17433aca54539b577226d2c27c3b92e5.svg";